import {Component} from '@angular/core';
import {AlertController, NavController} from 'ionic-angular';
import {MyEditPage} from "../my-edit/my-edit";

@Component({
  selector: 'page-my-info',
  templateUrl: 'my-info.html'
})
export class MyInfoPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController, private alertCtrl: AlertController) {
  }

  goToMyEdit(params) {
    if (!params) params = {};
    this.navCtrl.push(MyEditPage);
  }

  goToInvite(params) {
    if (!params) params = {};
    this.presentAlert();
    this.navCtrl.parent.select(3);
  }
  presentAlert() {
    let alert = this.alertCtrl.create({
      title: 'Share from My Info',
      subTitle: 'What is the workflow for this button? Spec states should go to Invite, but then what happens? ' +
      'How are we sharing what with whom?',
      buttons: ['Dismiss']
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/my-info/my-info.ts